import React from 'react';

import { SyteApiProvider } from '@apis/syte/syte-api-provider';
import { useSyteApiMapig } from '@apis/syte/use-syte-api-mapig';
import { useGetUserInfo } from '@packages/legacy/auth';
import { useOrganizationContext } from '@packages/legacy/organization-context';
import { env } from '@packages/utils/env';

export const UpApiProvider = ({ children }: React.PropsWithChildren) => {
  const apiClient = useSyteApiMapig();
  const user = useGetUserInfo();
  const { selectedOrganization } = useOrganizationContext();
  return (
    <SyteApiProvider
      value={{
        fetchData: apiClient,
        organizationId: selectedOrganization.id,
        mockedData: env.MODE === 'e2e',
        organizationName: selectedOrganization.name,
        loggedUser: user?.email ?? '',
        userIsCollaborator: false,
        userIsProspect: false,
        userIsReadOnly: false,
      }}
    >
      {children}
    </SyteApiProvider>
  );
};
